<template>
    <tbody>
        <tr v-for="(item, index) in items" v-bind:key="index">
            <td>
                {{ item.product.name }}<br>
                SKU: {{ item.product.sku }}<br>
                <div v-if="itemHasPlans(item)">
                    <a :href="'/coach/plans/'+item.plans[0].id" class="btn btn-sm btn-light" ><i class="mdi mdi-file-document-box-outline"></i> View Plan(s) ></a>
                </div>
                <div v-if="!itemHasPlans(item)">
                    <button class="btn btn-sm btn-secondary" @click="createPlans(item)"><i class="mdi mdi-file-document-box-outline"></i> Create Plans</button>
                </div>
                <small v-if="item.created_by" class="text-info">*Item created by {{ item.created_by.first_name }} {{ item.created_by.last_name }}</small>
            </td>
            <td>{{ item.fulfillment_status }}</td>
            <td>{{ item.quantity }}</td>
            <td>{{ item.total_price }}</td>
            <td>
              <button class="btn btn-sm btn-secondary" v-if="itemCanBeEdited(item)" @click="editItem(item)"><i class="mdi mdi-pencil"></i></button>
              <button class="btn btn-sm btn-danger" v-if="itemCanBeDeleted(item)" @click="deleteItem(item)"><i class="mdi mdi-trash-can-outline"></i></button>
            </td>
        </tr>
        <tr v-if="items.length == 0">
            <td colspan="5">
                No items yet.  :'(
            </td>
        </tr>
    </tbody>
</template>
<script>
  export default {
    data() {
        return {
        }
    },
    computed: {
    },
    methods: {
        itemCanBeEdited: function(item) {
            return !(item.plans && item.plans.length > 0);
        },
        itemCanBeDeleted: function(item) {
            return !(item.plans && item.plans.length > 0);
        },
        itemHasPlans: function(item) {
            return item.plans && item.plans.length > 0;
        },
        itemUpdated: function(item) {
            this.$emit('item-updated', item);
        },
        emitItemDeleted: function(item) {
            this.$emit('item-deleted', item);
        },
        deleteItem(item) {
            var _this = this;
            axios.delete('/api/orders/items/' + item.id)
            .then(function (response) {
                _this.emitItemDeleted(item);
            });
        },
        editItem(item) {
            var _this = this;
            _this.$parent.editItem(item);
        },
        createPlans(item) {
          var _this = this;
          // _this.$parent.editItem(item);
          axios.post('/api/orders/items/' + item.id + '/plans')
          .then(function (response) {
            item.plans = [...item.plans, ...response.data.data];
            _this.itemUpdated(item);
            _this.$toasted.success(response.data.data.length + " Plan(s) created!");
            _this.isLoading = false;
          }).catch(e => {
            _this.$toasted.error(e.response.data.message);
            _this.isLoading = false;
          })
        },
    },
    props: [
        'items'
    ],
    filters: {
      // properCase(string) {
      //   return string.charAt(0).toUpperCase() + string.slice(1);
      // }
    }
  }
</script>
<style></style>
